import { render } from "./Rtl.vue?vue&type=template&id=95695220"
import script from "./Rtl.vue?vue&type=script&lang=js"
export * from "./Rtl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__